export default "__VITE_ASSET__12ede668__"